exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home[data-v-53b37492] {\n  width: 100%;\n  margin-top: 159px;\n  text-align: center;\n}\n.home .title[data-v-53b37492] {\n  font-size: 14px;\n  font-weight: 400;\n  color: #252525;\n}\n.home .desc[data-v-53b37492] {\n  margin-top: 14px;\n  margin-bottom: 73px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #252525;\n}\n[data-v-53b37492] .el-button:active,\n.el-button[data-v-53b37492] {\n  color: #275FE8;\n  border-color: #275FE8;\n}", ""]);

// exports
